module.exports = __webpack_public_path__ + "img/SK36861260.06eca2ac.png";